import endPoint from '@/libs/endPoint/ava/Comentarios.endpoint';
import ApiServices from '@/services/uteis/ApiServices.js';
class ComentariosServices {
  constructor() {
    this.endPoint = endPoint;
    this.ApiServices = ApiServices;
  }
  async Load(params = {}) {
    try {
      const url = this.endPoint.main;
      const { data } = await this.ApiServices.get(url, params);
      return data;
    } catch (error) {
      console.error('Error loading institution list:', error);
      throw error;
    }
  }
  async insert(params = {}) {
    try {
      const url = this.endPoint.main;
      const { data } = await this.ApiServices.post(url, params);
      return data;
    } catch (error) {
      console.error('Error loading institution list:', error);
      throw error;
    }
  }
} // fim classe
export default new ComentariosServices();
